import React, { FC, useCallback } from 'react'
import { BasicModal } from './index'
import { CautionHeadline, Description } from 'components/Typography'
import { Spacer } from 'components/Utility'
import { CautionButton, GreyButton } from 'components/Button'
import { FlexRow } from 'components/Flex'
import { useDispatch, useSelector } from 'react-redux'
import { State } from 'index'
import { closeCautionModal } from 'reducks/modal/operations'
import {
  getCautionActionLabel,
  getCautionCancelLabel,
  getCautionDescription,
  getCautionOnClickAction,
  getCautionOpen,
  getCautionTitle,
  getCautionActionType,
} from 'reducks/modal/selectors'

const CommonCautionModal: FC = () => {
  const dispatch = useDispatch()
  const actionLabel = useSelector((state: State) => getCautionActionLabel(state))
  const cancelLabel = useSelector((state: State) => getCautionCancelLabel(state))
  const description = useSelector((state: State) => getCautionDescription(state))
  const onClickAction = useSelector((state: State) => getCautionOnClickAction(state))
  const open = useSelector((state: State) => getCautionOpen(state))
  const caution = useSelector((state: State) => getCautionTitle(state))
  const actionType = useSelector((state: State) => getCautionActionType(state))

  const closeModal = useCallback(() => {
    dispatch(closeCautionModal())
  }, [dispatch])

  return (
    <BasicModal open={open} closeModal={closeModal}>
      <CautionHeadline align={'left'} caution={caution} />
      {description !== '' && (
        <>
          <Spacer size={12} />
          <Description description={description} />
        </>
      )}
      <Spacer size={24} />
      <FlexRow justifyContent={'center'}>
        <GreyButton
          label={cancelLabel !== '' ? cancelLabel : ''}
          onClick={closeModal}
          size={'small'}
          type={'outlined'}
        />
        <Spacer size={16} />
        {onClickAction && actionLabel !== '' && (
          <CautionButton
            label={actionLabel}
            onClick={() => {
              onClickAction()
              closeModal()
            }}
            size={'small'}
            type={actionType}
          />
        )}
      </FlexRow>
    </BasicModal>
  )
}

export default CommonCautionModal
